// client/src/components/influencer/InfluencerHomeHeader.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { clearAllSNSCache } from '../../utils/snsAccountCache';
import { clearAllApplyCache } from '../../utils/warmApplyCache';
import { clearInfluencerContractCache } from '../../utils/influencerContractCache';
import { clearInfluencerResultCache } from '../../utils/influencerResultCache';
import { usePoints } from '../../contexts/PointContext';

const API_URL = process.env.REACT_APP_API_URL;

function InfluencerHomeHeader() {
	const nav = useNavigate();
	const { points, loading, isRefreshing } = usePoints();
	const goHome = () => nav('/influencer/mybiz');
	const goGuide = () => window.open('/guide', '_blank', 'noopener,noreferrer');
	const prefetchNotices = () => {
		fetch(`${API_URL}/api/notices?page=1&pageSize=15`, { credentials: 'include' })
			.then(r => r.json()).then(j => { if (j?.ok) localStorage.setItem('notice_p1', JSON.stringify(j)); })
			.catch(()=>{});
	};
	
	const goNotice = () => { try { sessionStorage.setItem('current_user_role', 'influencer'); } catch {} prefetchNotices(); nav('/notice', { state: { role: 'influencer' } }); }
	const goInquiry = () => nav('/inquiry', { state: { role: 'influencer' } });
	const goMybiz = () => nav('/influencer/mybiz', { state: { role: 'influencer' } });

	// 공개 진입점 (로그인 후에도 노출) — 추후 LP nav 스타일로 통합 예정
	const goMarketerLp = () => nav('/lp/marketer');
	const goInfluencerLp = () => nav('/lp/influencer');
	const goFaq = () => nav('/faq');

	const logout = async () => {
		try {
			await fetch(`${API_URL}/api/user/logout`, { method: 'POST', credentials: 'include' });
		} catch {}
		
		// ✅ 1. 모든 캐시 초기화 (window.__ME__ 삭제 전에!)
		const uid = window.__ME__?.id;
		clearAllSNSCache();
		clearAllApplyCache();
		clearInfluencerContractCache(uid);
		clearInfluencerResultCache(uid);
		
		// ✅ 2. sessionStorage 완전 초기화
		try {
			sessionStorage.removeItem('current_user_key');
			sessionStorage.removeItem('current_user_role');
			sessionStorage.removeItem('last_login_uid'); // ✅ 보안: 마지막 로그인 uid 삭제
			
			const keys = Object.keys(sessionStorage);
			keys.forEach(key => {
				if (key.startsWith('INF_') ||
				    key.startsWith('user_points_cache_')) { // ✅ 포인트 캐시 제거
					sessionStorage.removeItem(key);
				}
			});
		} catch {}
		
		// ✅ 3. localStorage 인플루언서 관련 캐시 초기화
		try {
			const keys = Object.keys(localStorage);
			keys.forEach(key => {
				if (key.startsWith('influencer_') || key.startsWith('inquiry_')) {
					localStorage.removeItem(key);
				}
			});
		} catch {}
		
		// ✅ 4. window.__ME__ 완전히 삭제
		if (window.__ME__) {
			delete window.__ME__;
		}
		
		// ✅ 5. warmup 타이머 정리
		if (window.__INF_WARM_TIMER) {
			clearInterval(window.__INF_WARM_TIMER);
			delete window.__INF_WARM_TIMER;
		}
		
		// ✅ 6. 페이지 새로고침으로 완전 초기화
		window.location.href = '/';
	};

	return (
		<header className="influencer-home-header influencer-header">
			<div className="influencer-header__left">
				<button className="influencer-header__logo-button" onClick={goHome} aria-label="인플루언서 홈으로">
					<img 
						src="/images/logo.svg" 
						alt="셀프애드" 
						className="influencer-header__logo"
					/>
				</button>
			{/* 상단 내비는 폭 제약으로 병기 제외 — 우측 로그아웃 버튼만 병기 유지 */}
			<button className="influencer-header__nav-button" onClick={goInfluencerLp}>인플루언서 안내</button>
				<button className="influencer-header__nav-button" onClick={goGuide}>서비스 가이드</button>
				<button className="influencer-header__nav-button" onClick={goNotice}>공지사항</button>
				<button className="influencer-header__nav-button" onClick={goFaq}>FAQ</button>
				<button className="influencer-header__nav-button" onClick={goInquiry}>문의하기</button>
				<button className="influencer-header__nav-button" onClick={goMybiz}>마이비즈</button>
			</div>
			
			<div className="influencer-header__right">
				{/* 포인트 표시 */}
				<div className={`influencer-header__points ${loading ? 'influencer-header__points--loading' : ''} ${isRefreshing ? 'influencer-header__points--refreshing' : ''}`}>
					<span className="influencer-header__points-label">💰</span>
					<span className="influencer-header__points-value">
						{loading ? '...' : points.toLocaleString()}
					</span>
					<span className="influencer-header__points-suffix">pt</span>
				</div>
				
				<button className="influencer-header__logout" onClick={logout}>로그아웃 (Log out)</button>
			</div>
		</header>
	);
}

export default InfluencerHomeHeader;
